import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { GqlFieldworkerGetAutocompleteOptionsParams } from "~/__generated__";

import { FieldworkerSelect_GetAutocompleteOptionsDocument } from "../queries.generated";

export default function useFieldworkerSelect_GetAutocompleteOptions(params: GqlFieldworkerGetAutocompleteOptionsParams) {
    const { data, previousData, loading } = useQuery(FieldworkerSelect_GetAutocompleteOptionsDocument, {
        variables: { params },
    });

    const options = useMemo(() => data?.fieldworkerGetAutocompleteOptions.data ?? [], [data]);
    const selectedOptions = useMemo(
        () => (data ?? previousData)?.fieldworkerGetAutocompleteOptions.selectedData ?? [],
        [data, previousData],
    );

    return { options, selectedOptions, loading };
}
